var RadialData = require('./radialData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var EllipseData = require('../../../svg/ellipseData.js');
var PathType = require('../../../svg/pathType.js');
var PthComponentAttribute = require('./pthComponentAttribute.js');
var IPCRules = require('../ipcRules');
var IPCPthFootprintCalculator = require('./pthCalculator.js');

var RadialLedRoundData = function(position, angle, init) {
    var self = this;
    RadialData.apply(this, arguments);

    this.leadShape = this.value("leadShape", true);
    this.terminalThickness = this.value("terminalThickness", true);
    this.bodyOffset = this.value("bodyOffset", true);
    this.customBodyColor = this.value("customBodyColor", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.leadShape);
    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalThickness);
    this.nonTransformedSegmentedGeometry.addTrigger(this.customBodyColor);
    this.bodyColor(PthComponentAttribute.bodyColors.RADIAL.ROUND.LED.Red.value);
    this.leadShape(PthComponentAttribute.leadShapes["Rectangle"]);
};

lib_core.inherit(RadialLedRoundData, RadialData);
lib_core.JsonParser.registerClass(RadialLedRoundData, "RadialLedRoundData");

module.exports = RadialLedRoundData;

RadialLedRoundData.prototype.setupMinMaxPtrMap = function() {
    RadialData.prototype.setupMinMaxPtrMap.call(this);
    this.colorValidationMap = {};

    this.validationMap["terminalThickness"] = [this.terminalThickness];

    this.colorValidationMap["customBodyColor"] = [this.customBodyColor]; 
};

RadialLedRoundData.prototype.getMinMaxFailures = function() {
    var fails = RadialData.prototype.getMinMaxFailures.call(this);
    for(var key in this.colorValidationMap){
        if(this.colorValidationMap.hasOwnProperty(key)){ 
            //check the entered hex value with a regular expression
            var str = this.colorValidationMap[key][0]();
            var regExp = /^#?[a-fA-F0-9]{3}([a-fA-F0-9]{3})?$/;
            if (!this.bodyColor()){
                if (regExp.test(str) == false){
                    fails.push(this.colorValidationMap[key]);
                }
            } 
        }
    }
   return fails; 
}

RadialLedRoundData.prototype.getTerminalDiameter = function() {
    if (this.leadShape() === PthComponentAttribute.leadShapes["Rectangle"]) {
        return Math.sqrt(this.terminalWidth() * this.terminalWidth() + this.terminalThickness() * this.terminalThickness());
    } else {
        return this.terminalWidth();
    }
}

/**
 * Calculate silkscreen for selected component. Silkscreen is calculated from body and pads geometry.
 * @param  {array} pads Pads calculated from getPads() function.
 * @return {array} Array of silkscreen data
 */
RadialLedRoundData.prototype.getSilkscreen = function(pads) {
    if(pads.length === 0) return;
    /*
        draw silkscreen on body
     */
    var silkscreen = [];
    var body = this.getBodyForSilkscreen();

    //Calculate parameters needed to ristict silkscreen from pads if pad overlap silkscreen data.
    //To calculate a,h and d see https://stackoverflow.com/questions/3349125/circle-circle-intersection-points
    var padWithClearance = pads[0].getTopCopper().width() / 2 + IPCRules.silkscreenClearance; //radius of clearence circle around pad.
    var d = 0.5 * this.verticalPinPitch(); //distance between pad center and silkscreen center

    //Flat edge line points on LED diamter
    var sideEdgeX = body.width / 2 * 0.9;
    var sideEdgeY = Math.sqrt(Math.pow(body.width / 2, 2) - Math.pow(sideEdgeX, 2));

    if (this.padShape() === PthComponentAttribute.padShapes["Round"]) {
        var a = (Math.pow(body.width / 2, 2) - Math.pow(padWithClearance, 2) + Math.pow(d,2)) / 2 / d; // X-coordinate of pad & silkscreen intersection point.
        var h = Math.sqrt(Math.pow(body.width / 2, 2) - Math.pow(a, 2)) // Y-coordinate of pad & silkscreen intersection point.
        var padIntersect = Math.sqrt(Math.pow(padWithClearance, 2) - Math.pow(sideEdgeX - d, 2)); //Y-coordinate of pad & silkscreen flat edge line intersection point.

    } else {
        var padIntersect = padWithClearance;
        //X and Y coordinates if silkcreen intersect on vertical edge of pad
        var a = d - padWithClearance;
        var h = Math.sqrt(Math.abs(Math.pow(body.width / 2, 2) - Math.pow(a, 2)));
        //X and Y coordinates if silkcreen intersect on horizontal edge of pad
        if (h >= padWithClearance){
            var a = Math.sqrt(Math.pow(body.width / 2, 2) - Math.pow(padWithClearance, 2));
            var h = padWithClearance;
        }
    };

    var angleAtIntersect = Math.atan2(h, -a);

    //Detect if pad intersect silkscreen and break the silkscreen into arcs. (pitch + padWithClearance * 2) > bodyWidth > (pitch - padWithClearance * 2)
    //For square pad additional check needed as below case if left corners of pad are touching/outside of arc and left edge of pad is inside arc.
    /*

            XXXX
         XXX
       XX
      XX
     XX--------+
     X         |
    X|         |
    X|         |
    X|         |
     X         |
     XX--------+
      XX
        XX
         XXX
            XXXX

    */
    if(((this.verticalPinPitch() + padWithClearance * 2) > body.width && (this.verticalPinPitch() - padWithClearance * 2) < body.width)
    || this.padShape() === PthComponentAttribute.padShapes["Square"] && Math.pow(d + padWithClearance, 2) + Math.pow(padWithClearance, 2) >= Math.pow(body.width / 2, 2) && d + padWithClearance < body.width / 2) {

        //Top side arc.
        var pathData = new PathData(new lib_geometry.Coord(-a, h), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(Math.min(a, sideEdgeX), Math.max(h, sideEdgeY)), PathType.ARC, new lib_geometry.Coord(-a, h), new lib_geometry.Coord(Math.min(a, sideEdgeX), Math.max(h, sideEdgeY)), body.width/2, body.width/2));
        silkscreen.push(pathData);

        //Bottom side arc.
        pathData = pathData.clone();
        pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
        silkscreen.push(pathData);
    }
    //Draw circle if pads are inside or outside of silkscreen data.
    else {
        //Top side arc.
        var pathData = new PathData(new lib_geometry.Coord(-body.width / 2, 0), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(sideEdgeX, sideEdgeY), PathType.ARC, new lib_geometry.Coord(-body.width / 2, 0), new lib_geometry.Coord(sideEdgeX, sideEdgeY), body.width/2, body.width/2));
        silkscreen.push(pathData);

        //Bottom side arc.
        pathData = pathData.clone();
        pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
        silkscreen.push(pathData);
    };

    //Flat edge line
    if((this.verticalPinPitch() / 2 + padWithClearance) > sideEdgeX && (this.verticalPinPitch() / 2 - padWithClearance) < sideEdgeX ) {
        if(padIntersect < sideEdgeY) {
            var sideEdgeLine = new PathData(new lib_geometry.Coord(sideEdgeX, sideEdgeY), IPCRules.silkscreenStrokeWidth);
            sideEdgeLine.addObject(new PathObjectData(new lib_geometry.Coord(sideEdgeX, padIntersect), PathType.LINE));
            silkscreen.push(sideEdgeLine);

            sideEdgeLine = sideEdgeLine.clone();
            sideEdgeLine.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
            silkscreen.push(sideEdgeLine);
        };
    } else {
        var sideEdgeLine = new PathData(new lib_geometry.Coord(sideEdgeX, sideEdgeY), IPCRules.silkscreenStrokeWidth);
        sideEdgeLine.addObject(new PathObjectData(new lib_geometry.Coord(sideEdgeX, -sideEdgeY), PathType.LINE));
        silkscreen.push(sideEdgeLine);
    };

    var pinMarkerSize = IPCRules.dotPinMarkerSize * 1.5;
    var maintainedClearence = IPCRules.silkscreenPinMarkerDotClearance;
    var pinMarkerX = - this.getBodyForAssembly().width / 2 - maintainedClearence - IPCRules.silkscreenStrokeWidth / 2;
    var pinMarkerAngle = -2.35619; // -135 degree

    //Update pin marker angle if pad data overlap with it.
    if(pinMarkerAngle < -angleAtIntersect) {
        pinMarkerAngle = -angleAtIntersect;
    };

    //Pin marker horizontal line.
    var pinMarker = new PathData(new lib_geometry.Coord(-pinMarkerX * Math.cos(pinMarkerAngle) - pinMarkerSize / 2, pinMarkerX * Math.sin(pinMarkerAngle) + pinMarkerSize / 2), IPCRules.silkscreenStrokeWidth);
    pinMarker.addObject(new PathObjectData(new lib_geometry.Coord(-pinMarkerX * Math.cos(pinMarkerAngle) + pinMarkerSize / 2, pinMarkerX * Math.sin(pinMarkerAngle) + pinMarkerSize / 2), PathType.LINE));
    silkscreen.push(pinMarker);

    //Pin marker vertical line.
    pinMarker = new PathData(new lib_geometry.Coord(-pinMarkerX * Math.cos(pinMarkerAngle), pinMarkerX * Math.sin(pinMarkerAngle) + pinMarkerSize), IPCRules.silkscreenStrokeWidth);
    pinMarker.addObject(new PathObjectData(new lib_geometry.Coord(-pinMarkerX * Math.cos(pinMarkerAngle), pinMarkerX * Math.sin(pinMarkerAngle)), PathType.LINE));
    silkscreen.push(pinMarker);

    return silkscreen;
};
